import { ActionTree } from 'vuex'
import { LocatorState } from './types'
import { RootState } from '@/store/types'

export const actions: ActionTree<LocatorState, RootState> = {
  setSearch({ commit }, payload) {
    commit('setSearch', payload)
  },
}
